import { register } from '../firebase/auth'
import {
  deleteSubDocument,
  deleteDocumentField,
  updateDocument,
  setSubDocument,
  getDocumentsWithQuery,
  updateSubDocument,
  addDocument,
  addSubDocument,
} from '../firebase/firestore'
import { DeleteUserAuthenticatorFromUid, GetUserAuthenticatorFromEmail } from '../firebase/functions'
import { deleteFile, getPathFile, uploadFile } from '../firebase/storage'
import { DateTimeNow } from './dates'

export const DeleteUser = async (uid, userInfo, clientId, setLoading, setAlerts, updateFuntion) => {
  try {
    setLoading(true)

    // deleta a foto de perfil
    if (userInfo && Object.prototype.hasOwnProperty.call(userInfo, 'key')) {
      const path = getPathFile(userInfo.photoUrl)
      await deleteFile(path)
    }

    // Deleta o usuário da base de dados do cliente
    await deleteSubDocument('clientes', clientId, 'users', uid)
    await deleteDocumentField('clientes', clientId, `users.${uid}`)

    // procura se o usuario esta cadastro em outro cliente
    const queryUsersTrue = await getDocumentsWithQuery('clientes', 'users.' + uid, '==', true)
    const queryUsersFalse = await getDocumentsWithQuery('clientes', 'users.' + uid, '==', false)

    const queryTotal = { ...queryUsersTrue, ...queryUsersFalse }
    const response = Object.values(queryTotal) || []

    // Deleta o autenticador do usuario se ele não estiver na base de dados de clientes
    if (response.length === 0) {
      try {
        await DeleteUserAuthenticatorFromUid(uid)
      } catch (error) {
        throw new Error(error.message)
      }
    }

    setAlerts((prev) => [
      ...prev,
      {
        type: 'success',
        title: 'Usuário deletado',
        msg: `Usuário deletado da sua base de dados`,
      },
    ])

    updateFuntion()

    setLoading(false)
  } catch (error) {
    throw new Error(error.message)
  }
}

export const NewUser = async (userInfo, clientID, setAlerts, password = 'keap123', uploadPhoto = true) => {
  try {
    let response

    // tenta realizar o registro do usuário no authenticador
    response = await register(userInfo.email, password)
    // console.log(response)
    // se o usuário ja possui cadastro no autenticador, ele coleta o UID;
    if (response.error) {
      response = await GetUserAuthenticatorFromEmail(userInfo.email)
      // caso ele não consiga criar ou achar o usuário, ele para e mostra o erro na tela;
      // console.log(response)
      if (response.error) {
        // console.log('entrei')
        setAlerts((prev) => [
          ...prev,
          {
            title: 'Erro ao criar usuário',
            msg: `erro: ${response.error}`,
            type: 'error',
          },
        ])
        return response
      }
      // console.log('entrei')
      setAlerts([
        {
          title: 'Usuário Vinculado',
          msg: `O e-mail ${userInfo?.email} já está registrado no sistema e foi vinculado a este cliente.`,
          type: 'success',
        },
      ])
    } else {
      // console.log(response)
      setAlerts([
        {
          title: 'Usuário Criado',
          msg: `O usuário foi criado com o e-mail: ${userInfo?.email} e a senha: keap@123.`,
          type: 'success',
        },
      ])
    }
    // console.log(response)
    // caso possua uma imagem para fazer upload
    if (Object.keys(userInfo).includes('photoUrl') && uploadPhoto) {
      const pathUploadFile = `users/${clientID}/foto_${response.uid}`
      const urlFoto = await uploadFile(userInfo.photoUrl, pathUploadFile)
      userInfo = { ...userInfo, photoUrl: urlFoto }
    }

    // adiciona o uid no map "users" do cliente e na SubCollection "users"
    await updateDocument('clientes', `${clientID}`, {
      [`users.${response.uid}`]: true,
    })
    await setSubDocument('clientes', `${clientID}`, 'users', response.uid, userInfo)

    // volta pra pagina inicial de usuarios;
    // console.log(response)
    return response
  } catch (error) {
    throw new Error(error.message)
  }
}

// criar um new authenticator, só para retornar o uuid

export const NewUserAuth = async (userInfo, setAlerts, password = 'keap123') => {
  try {
    let response

    // tenta realizar o registro do usuário no authenticador
    response = await register(userInfo.email, password)
    // console.log(response)
    // se o usuário ja possui cadastro no autenticador, ele coleta o UID;
    if (response.error) {
      response = await GetUserAuthenticatorFromEmail(userInfo.email)
      // caso ele não consiga criar ou achar o usuário, ele para e mostra o erro na tela;
      // console.log(response)
      if (response.error) {
        response.userExists = false
        // console.log('entrei')
        setAlerts((prev) => [
          ...prev,
          {
            title: 'Erro ao criar usuário',
            msg: `erro: ${response.error}`,
            type: 'error',
          },
        ])
        return response
      }
      // console.log('entrei')
      response.userExists = true

      setAlerts((prev) => [
        ...prev,
        {
          title: 'Usuário Vinculado',
          msg: `O e-mail ${userInfo?.email} já está registrado no sistema.`,
          type: 'success',
        },
      ])
    } else {
      // console.log(response)
      response.userExists = false

      setAlerts((prev) => [
        ...prev,
        {
          title: 'Usuário Criado',
          msg: `O usuário foi criado com o e-mail: ${userInfo?.email} e a senha: ${password}.`,
          type: 'success',
        },
      ])
    }
    // console.log(response)

    // volta pra pagina inicial de usuarios;
    // console.log(response)
    return response
  } catch (error) {
    throw new Error(error.message)
  }
}

export const EditUser = async (userInfo, clientID, setAlerts) => {
  // caso possua uma imagem para fazer upload
  if (Object.keys(userInfo).includes('photoUrl')) {
    if (!String(userInfo.photoUrl).includes('https://')) {
      const pathUploadFile = `users/${clientID}/foto_${userInfo.uid}`
      const urlFoto = await uploadFile(userInfo.photoUrl, pathUploadFile)
      userInfo = { ...userInfo, photoUrl: urlFoto }
    }
  }

  updateSubDocument('clientes', clientID, 'users', userInfo.uid, userInfo)

  setAlerts((prev) => [
    ...prev,
    {
      type: 'success',
      title: 'Usuário Atualizado',
      msg: `O usuário ${userInfo.nome} foi atualizado com sucesso!`,
    },
  ])
}

export const SetHistorySystem = async (user, type, info) => {
  const newHistory = {
    time: new Date().getTime(),
    dt_modified: DateTimeNow(),
    modified_by: user,
    type_modified: type,
    info,
  }

  // adiciona um historico
  try {
    await addDocument('history', newHistory)
  } catch (error) {
    console.error('Erro ao adicionar histórico:', error)
  }
}

export const SetHistoryEvent = async (eventId, userModified, typeModified, info = {}) => {
  const newHistory = {
    time: new Date().getTime(),
    dtModified: DateTimeNow(),
    modifiedBy: userModified,
    typeModified,
    info,
  }

  // adiciona um historico
  try {
    await addSubDocument('events', eventId, 'history', newHistory)
  } catch (error) {
    console.error('Erro ao adicionar histórico do evento:', error)
  }
}

export const SetHistoryClient = async (clientId, user, type, info) => {
  const newHistory = {
    time: new Date().getTime(),
    dt_modified: DateTimeNow(),
    modified_by: user,
    type_modified: type,
    info,
  }

  // adiciona um historico
  try {
    await addSubDocument('clientes', clientId, 'history', newHistory)
  } catch (error) {
    console.error('Erro ao adicionar histórico:', error)
  }
}
